import { useStore } from "../../../../../helpers";
import { useRequestTypeMutation } from "../../../sr-hooks";
import { useTranslation } from "react-i18next";

export const useEditStatus = () => {
  const rootStore = useStore();
  const { t } = useTranslation("service_request_settings")

  const editStatusMeta = async (payload) => {
    return rootStore.apiRequestHandler(
      "unified_service_request/sr-statuses-update",
      payload,
      t("status_edit_status_failed"),
    );
  };

  return useRequestTypeMutation(editStatusMeta, t("status_edit_status_success"));
};
